import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// index.css — чистый CSS, @import scss оттуда не собирается, поэтому
// вендорные оверрайды подключаем здесь, после него
import "./styles/vendors/jivo.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ErrorProvider } from "./Components/Admin/ErrorRequest/ErrorProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorProvider>
      <App />
    </ErrorProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
